import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { authAPI } from '../api';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.forgotPassword({ email });
      setSent(true);
    } catch { toast.error(t('error')); }
    finally { setLoading(false); }
  };

  const inp = { width:'100%', background:'var(--surface2)', border:'1px solid var(--border)', borderRadius:10, padding:'12px 16px', color:'var(--text)', fontSize:15, outline:'none', boxSizing:'border-box' };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'radial-gradient(ellipse 80% 60% at 50% -10%,#2d1f7a44,transparent),var(--bg)', padding:20 }}>
      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:24, padding:48, width:'100%', maxWidth:420 }}>
        <div style={{ fontFamily:'Syne,sans-serif', fontSize:24, fontWeight:800, background:'linear-gradient(135deg,#7c6af7,#f7c26a)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', marginBottom:24 }}>BudgetFlow</div>
        {sent ? (
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:48, marginBottom:16 }}>📬</div>
            <h2 style={{ fontFamily:'Syne,sans-serif', marginBottom:12 }}>Email envoye !</h2>
            <p style={{ color:'var(--text2)', marginBottom:24 }}>Si cet email existe, vous recevrez un lien de reinitialisation.</p>
            <Link to="/login" style={{ color:'var(--accent)', textDecoration:'none', fontSize:14 }}>{t('back_to_login')}</Link>
          </div>
        ) : (
          <>
            <h2 style={{ fontFamily:'Syne,sans-serif', fontSize:20, fontWeight:700, marginBottom:8 }}>{t('forgot_password')}</h2>
            <p style={{ color:'var(--text2)', fontSize:14, marginBottom:28 }}>Entrez votre email pour recevoir un lien de reinitialisation.</p>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom:20 }}>
                <label style={{ display:'block', fontSize:13, color:'var(--text2)', marginBottom:8 }}>{t('email')}</label>
                <input type="email" required value={email} onChange={e => setEmail(e.target.value)} style={inp} />
              </div>
              <button type="submit" disabled={loading} style={{ width:'100%', padding:14, background:'var(--accent)', color:'#fff', border:'none', borderRadius:10, fontFamily:'Syne,sans-serif', fontWeight:700, fontSize:15, cursor:'pointer' }}>
                {loading ? t('loading') : t('send_reset')}
              </button>
            </form>
            <p style={{ textAlign:'center', marginTop:20, fontSize:13 }}>
              <Link to="/login" style={{ color:'var(--accent)', textDecoration:'none' }}>{t('back_to_login')}</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}